export const URL_ROUTES = {
    index :                     "/",

    projects :                  "/projects",
    projects_budget_it:         "/projects/budget-it",
    projects_thoughts:          "/projects/thoughts-sharing",
    projects_smart_dictionary:  "/projects/smart-dictionary",

    about:                      "/about-me",
    contact:                    "/contact-me",

    other_travel:               "miscellaneous/travel",

    a_linkedIn:                 "https://www.linkedin.com/in/jashan7/",
    a_github:                   "https://github.com/Jashann",
    a_email:                    "gilljs5@myumanitoba.ca",
    a_email_personal:           "gilljs5@myumanitoba.ca",
    a_phone:                    "(604) 772-2002",
    location:                   "Winnipeg, MB, Canada",
}

